import React from 'react'
import Construction from '../components/animations/Construction'

export default function Categories(props) {


  return (
    <div style={{ backgroundColor: "#2d2f2d",paddingTop:80}}>
        <div style={{
          display: 'flex', flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white', fontSize: '22px' }}>
          <div style={{fontSize: '46px' }}>Categories</div>
          <div style={{ paddingTop:20, paddingBottom:100}}>
          <Construction />
        </div>
      </div>
    </div>
  )
}
